import { defineStore } from "pinia";
import { reactive } from "vue";

export const useModalService = defineStore("ModalService", () => {
  const modal = reactive({
    isVisible: false,
    title: "",
    message: "",
    icon: null,
    buttons: [],
    content: null,
    props: {},
  });

  function show({
    title = "Notice",
    message = "",
    icon = null,
    buttons = [],
    content = null,
    props = {},
  }) {
    Object.assign(modal, {
      isVisible: true,
      title,
      message,
      icon,
      buttons,
      content,
      props,
    });
  }

  function close() {
    modal.isVisible = false;
  }

  return { modal, show, close };
});
